import React, { memo } from 'react';
import { Link } from '@components/Link';

type DiscountBanner = {
  textColor: string;
  backgroundColor: string;
  primaryText: string;
  secondaryText?: string;
  url?: string;
};

type Props = {
  discountBanner: DiscountBanner | null | undefined;
  className?: string;
};

export const ProductDiscountBanner: React.FC<Props> = ({ className, discountBanner }) => {
  if (!discountBanner) return null;

  const banner = (
    <div
      className={`promo-bar promo-bar-discount ${className}`}
      style={{ color: discountBanner.textColor, backgroundColor: discountBanner.backgroundColor }}>
      <div className='discount'>{discountBanner.primaryText}</div>
      {discountBanner.secondaryText && <div className='terms'>{discountBanner.secondaryText}</div>}
    </div>
  );

  return discountBanner.url ? (
    <Link href={discountBanner.url} className='tw:no-underline'>
      {banner}
    </Link>
  ) : (
    banner
  );
};

export default memo(ProductDiscountBanner);
